export default {
  manage: {
    plans: {
      modify: { resource: 'manage-plans', code: 'modify' },
    },
    emails: {
      template: {
        access: { resource: 'manage-emails', code: 'access_templates' },
        modify: { resource: 'manage-emails', code: 'modify_templates' },
      },
      unsubscribers: {
        access: { resource: 'manage-emails', code: 'access_unsubscribers' },
      },
    },
    users: {
      contractors: {
        access: { resource: 'manage-contractors', code: 'access' },
      },
      partners: {
        access: { resource: 'manage-partners', code: 'access' },
      },
    },
  },
};
